import { PopoverOrigin } from '@mui/material';
import { PopoverArrowProps } from '@procureai/ui-mui';
import { ReactNode, forwardRef } from 'react';

import { PopoverArrowStyled, Content } from './HoverMenu.styled';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export interface HoverMenuProps extends Omit<PopoverArrowProps, 'children'> {
  onItemClick?: (item: any) => void;
  children?: () => ReactNode;
}

export const HoverMenu = forwardRef<any, HoverMenuProps>(function HoverMenu(
  { onItemClick, children, ...otherProps },
  ref,
) {
  return (
    <PopoverArrowStyled
      ref={ref}
      hideBackdrop
      disableScrollLock
      anchorOrigin={ANCHOR_ORIGIN}
      transformOrigin={TRANSFORM_ORIGIN}
      PaperProps={{ onMouseLeave: otherProps.onClose as any }}
      {...otherProps}
    >
      <Content>{children && children()}</Content>
    </PopoverArrowStyled>
  );
});
